<template>
  <div>
    <el-drawer :visible.sync="dialogVisible" direction="rtl" :modal="false" :before-close="handleClose">
      <template slot="title">
        <div>
          <el-radio-group v-model="activeName" class="radioGroup" @change="changeTab">
            <el-radio-button label="orderData">工单数据</el-radio-button>
            <el-radio-button label="flowPath">办理流程</el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <div class="orderDetail" id="orderDetail" @mousewheel="scrollChange">
        <div class="title" id="orderData">
          <div class="status" :style="{ background: getStatus(detail.orderStatus).color }">
            {{ getStatus(detail.orderStatus).name }}
          </div>
          <div class="txt">工单类型：{{ detail.orderTypeName }}</div>
          <div class="txt">工单编号：{{ detail.orderId }}</div>
        </div>
        <div class="theme">{{ detail.orderContent }}</div>
        <div class="detail">
          <div class="detailItem">
            <div class="label">项目名称：</div>
            <div class="value">{{ detail.projectName || '--' }}</div>
          </div>
          <!-- <div class="detailItem">
            <div class="label">工单详情：</div>
            <div class="value">{{detail.orderContent || '--'}}</div>
          </div> -->
          <div class="detailItem">
            <div class="label">截止日期：</div>
            <div class="value">{{ detail.orderDate || '--' }}</div>
          </div>
          <div class="detailItem">
            <div class="label">作业区域：</div>
            <div class="value">{{ detail.projectAreaName || '--' }}</div>
          </div>
          <div class="detailItem">
            <div class="label">作业地点：</div>
            <div class="value">{{ detail.address || '--' }}<span @click="onAddressShow"
                v-if="detail.longitude && detail.latitude && showLocation">查看定位</span></div>
          </div>
          <div class="detailItem">
            <div class="label">详细位置描述：</div>
            <div class="value">{{ detail.projectPosition || '--' }}</div>
          </div>
          <div class="detailItem">
            <div class="label">现场图像：</div>
            <div class="fileList" v-if="detail.fileList && detail.fileList.length > 0">
              <div class="fileBlock" v-for="(item, index) in detail.fileList" :key="index">
                <el-image v-if="isImg(item)" :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="detail.fileList | imgListFormat" fit="fill">
                </el-image>
                <video v-if="isVideo(item)" controls="controls" :src="item.filePrefix + item.fileUrl"
                  :preview-src-list="[item.filePrefix + item.fileUrl]" fit="fill">
                </video>
              </div>
            </div>
            <div v-else>--</div>
          </div>
        </div>
        <div class="flowList" :style="'margin-bottom:' + getMarginBottom() + 'px'" id="flowPath">
          <div class="flowItem">
            <div class="icon">
              <i class="iconfont icon-imag_chuli_bg" :style="'color:#00B8AF'"></i>
              <span>发起</span>
            </div>
            <div class="flowInfo">
              <div class="info">
                <div class="infoRole">{{ detail.createUserRole || '' }}</div>
                <div class="infoTime">{{ detail.ctime }}</div>
              </div>
              <div class="name">{{ detail.createUserName }}</div>
            </div>
          </div>
          <div class="flowItem" v-for="(item, index) in detail.flowList || []" :key="index">
            <div class="icon">
              <div class="closeItem" v-if="item.flowType === '4'"></div>
              <i class="iconfont icon-imag_chuli_bg" v-else
                :style="'color:' + typeList[Number(item.flowType) - 1].color"></i>
              <span>{{ typeList[Number(item.flowType) - 1].value || '' }}</span>
            </div>
            <div class="flowInfo">
              <div class="info">
                <div class="infoRole">{{ item.userRole || '' }}</div>
                <div class="infoTime">{{ item.ctime || '' }}</div>
              </div>
              <div class="name">{{ item.userName || '' }}</div>
              <div class="remark">
                <div v-if="item.flowType === '3'">转办至 <span class="leftWidth">{{ item.receiveUserName || '' }}</span>
                </div>
                <div v-if="item.flowType === '2'">{{ item.result === '0' ? '通过' : item.result === '1' ? '驳回' : '' }}
                </div>
                <div><span>{{ typeList[Number(item.flowType) - 1].value || '' }}说明：</span><span>{{ item.remark ||
                  '' }}</span>
                </div>
              </div>
              <div class="fileList" v-if="item.fileList && item.fileList.length > 0">
                <div class="fileBlock" v-for="(items, index) in item.fileList" :key="index">
                  <el-image v-if="imgList.find((itemx) => itemx === items.fileName.split('.')[1].toLowerCase())"
                    :src="items.filePrefix + items.fileUrl" :preview-src-list="item.fileList | imgListFormat"
                    fit="fill">
                  </el-image>
                  <video v-if="videoList.find((itemx) => itemx === items.fileName.split('.')[1].toLowerCase())"
                    controls="controls" :src="items.filePrefix + items.fileUrl"
                    :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="handleForm" v-if="handleButtonShow">
          <div class="icon">
            <i class="iconfont icon-imag_chuli_bg" :style="'color:' + typeList[handleDialogType].color"></i>
            <span>{{ typeList[handleDialogType].value || '' }}</span>
          </div>
          <div class="form">
            <el-form ref="form" class="global-form2" :model="info" :rules="rules" label-position="right"
              label-width="100px">
              <!-- 转办处理人 -->
              <el-form-item prop="receiveUserId" label="转办至" v-if="handleDialogType === '2'">
                <el-select v-model="info.receiveUserId" placeholder="请选择处理人">
                  <el-option v-for="item in getTransferList()" :key="item.userId" :label="item.userName"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
              <!-- 反馈时选择 - 审核处理人 -->
              <el-form-item prop="userId" label="处理人" v-if="handleDialogType === '0'">
                <el-select v-model="info.userId" placeholder="请选择处理人">
                  <el-option v-for="item in reviewerList" :key="item.userId" :label="item.userName"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
              <!-- 审核结果 -->
              <el-form-item prop="result" label="审核结果" v-if="handleDialogType === '1'">
                <div class="radioItem" @click="radioChange('0')">
                  <img src="@/assets/img/workOrder/icon_tongguo.png" v-if="info.result === '0'">
                  <img src="@/assets/img/workOrder/icon_tongguo_nor.png" v-else>
                  <span>审核通过</span>
                </div>
                <div class="radioItem" @click="radioChange('1')">
                  <img src="@/assets/img/workOrder/icon_bohui.png" v-if="info.result === '1'">
                  <img src="@/assets/img/workOrder/icon_bohui_nor.png" v-else>
                  <span>审核驳回</span>
                </div>
              </el-form-item>
              <el-form-item prop="remark" :label="typeList[handleDialogType].value + '说明'">
                <el-input type="textarea" maxlength="200"
                  :placeholder="'请输入' + typeList[handleDialogType].value + '说明（必填）'" :rows="3" show-word-limit
                  v-model="info.remark"></el-input>
              </el-form-item>
              <!-- 审核说明 -->
              <el-form-item label="" v-if="handleDialogType === '1'">
                <span>驳回后该问题会要求返工并再反馈</span>
              </el-form-item>
              <!-- 反馈图片 -->
              <el-form-item prop="fileList" v-if="handleDialogType === '0'">
                <div class="imgList">
                  <template v-if="info.fileList.length > 0">
                    <div class="imgBlock" v-for="(item, index) in info.fileList" :key="index">
                      <!-- <el-image :src="item.filePrefix + item.fileUrl"
                        :preview-src-list="info.fileList | imgListFormat"
                        fit="fill">
                      </el-image> -->
                      <el-image v-if="imgList.find((items) => items === item.fileName.split('.')[1].toLowerCase())"
                        :src="item.filePrefix + item.fileUrl" :preview-src-list="info.fileList | imgListFormat"
                        fit="fill">
                      </el-image>
                      <video v-if="videoList.find((items) => items === item.fileName.split('.')[1].toLowerCase())"
                        controls="controls" :src="item.filePrefix + item.fileUrl"
                        :preview-src-list="[item.filePrefix + item.fileUrl]" fit="fill">
                      </video>
                      <i class="el-icon-close" @click="imgRemove(index)"></i>
                    </div>
                  </template>
                  <UploadFile :accept="'mp4,mov,jpeg,jpg,png'" v-if="info.fileList.length < 6" @onSuccess="onSuccess"
                    :slotShow='true'>
                    <template>
                      <i class="el-icon-plus"></i>
                      <p>上传图像</p>
                    </template>
                  </UploadFile>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="handleButton" v-if="detail.orderStatus !== '3' && detail.orderStatus !== '2'">
          <div class="handle" v-if="handleButtonShow">
            <el-button type="primary" :disabled="submitShow" @click="toSubmit()">确认</el-button>
            <el-button @click="toClose">取消</el-button>
          </div>
          <div class="check" v-if="!handleButtonShow">
            <el-button type="primary" @click="toHandle()"
              v-if="$ButtonShow('YOD_ADD_06') || userInfo.userId === detail.orderUserId">处理</el-button>
            <el-button type="primary" @click="toHandle('2')"
              v-if="$ButtonShow('YOD_ADD_05') || userInfo.userId === detail.orderUserId">转办</el-button>
          </div>
          <el-button class="closeBtn"
            v-show="($ButtonShow('YOD_ADD_07') || detail.createUserId === userInfo.userId) && !handleButtonShow"
            @click="toHandle('3')">关闭</el-button>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="地图定位" :visible.sync="addressShow" :close-on-click-modal="false" class="dialog-form" width="800px">
      <div id="map"></div>
    </el-dialog>
  </div>
</template>

<script>
import UploadFile from '@/components/uploadFile/Index.vue'
import LocationImg from '@/assets/img/icon_address.png'

export default {
  name: 'OrderDetailDialog',
  components: { UploadFile },
  props: {
    detailShow: {
      type: Boolean,
      default: false
    },
    isMyOrder: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    handleType: {
      type: String,
      default: ''
    },
    showLocation: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeName: 'orderData',
      detail: {
        projectId: '',
        orderType: '',
        orderTitle: '',
        orderContent: '',
        orderDate: '',
        address: '',
        fileList: [],
        orderUserId: '',
        flowList: []
      },

      info: {
        remark: '',
        userId: '',
        fileList: [],
        result: '',
        receiveUserId: ''
      },
      imgList: ['jpeg', 'jpg', 'png'],
      videoList: ['mp4', 'mov'],
      typeList: [
        {
          value: '反馈',
          color: '#F5A623'
        },
        {
          value: '审核',
          color: '#D0021B'
        },
        {
          value: '转办',
          color: '#00B8AF'
        },
        {
          value: '关闭',
          color: '#9B9B9B'
        }
      ],

      handleButtonShow: false,
      handleDialogType: '0',
      submitShow: false,
      feedbackList: [],
      reviewerList: [],
      map: null,
      marker: [],
      addressShow: false,
      scrollview: null,
      orderStatusList: [
        {
          name: '待反馈',
          color: '#F5A623'
        },
        {
          name: '待审核',
          color: '#F5A623'
        },
        {
          name: '已完成',
          color: '#00B8AF'
        },
        {
          name: '已关闭',
          color: '#9B9B9B'
        }
      ],

      rules: {
        remark: [
          { required: true, message: '请输入说明', trigger: ['blur', 'change'] }
        ],
        result: [
          { required: true, message: '请选择审核结果', trigger: ['blur', 'change'] }
        ],
        receiveUserId: [
          { required: true, message: '请选择处理人', trigger: ['blur', 'change'] }
        ],
        userId: [
          { required: true, message: '请选择处理人', trigger: ['blur', 'change'] }
        ]
      }

    }
  },
  computed: {
    userInfo() {
      return JSON.parse(sessionStorage.getItem('userInfo'))
    }
  },
  watch: {
    detailShow: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val
      }
    }
  },
  filters: {
    imgListFormat(list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((item) => {
        const str = item.fileName ? item.fileName.split('.') : item.fileUrl ? item.fileUrl.split('.') : []
        if (str.length && imgTypeList.find((items) => items === str[str.length - 1].toLowerCase())) {
          imgList.push(item.filePrefix + item.fileUrl)
        }
      })
      return imgList || []
    }
  },

  created() {
    this.handleDialogType = this.handleType
    this.handleButtonShow = this.handleType !== '4'
    this.getDetail()
  },
  methods: {
    isImg(item) {
      const str = item.fileName ? item.fileName.split('.') : item.fileUrl ? item.fileUrl.split('.') : []
      return str.length ? this.imgList.find((items) => items === str[str.length - 1].toLowerCase()) : false
    },
    isVideo(item) {
      const str = item.fileName ? item.fileName.split('.') : item.fileUrl ? item.fileUrl.split('.') : []
      return str.length ? this.videoList.find((items) => items === str[str.length - 1].toLowerCase()) : false
    },
    // 滚动tab切换
    scrollChange() {
      const anchor = document.getElementById('flowPath')
      const orderDetailHeight = document.getElementById('orderDetail')
      if (anchor && orderDetailHeight) {
        if (orderDetailHeight.scrollTop > anchor.offsetTop) {
          this.activeName = 'flowPath'
        } else {
          this.activeName = 'orderData'
        }
      }
    },

    getDetail() {
      this.$axios.get(this.$apis.workOrder.selectWorkOrderByOrderId, {
        orderId: this.orderId
      }).then(res => {
        this.detail = res || {}
      }).finally(() => {
        this.getFeedbackList()
        this.getReviewerList()
      })
    },

    // 反馈候选人
    getFeedbackList() {
      this.$axios.get(this.$apis.workOrder.selectOrderTypeFeedbackUserByList, {
        orderType: this.detail.orderType,
        projectId: this.detail.projectId
      }).then(res => {
        this.feedbackList = res || []
      })
    },

    // 审核候选人
    getReviewerList() {
      this.$axios.get(this.$apis.workOrder.selectOrderTypeApproveUserByList, {
        orderType: this.detail.orderType,
        projectId: this.detail.projectId
      }).then(res => {
        this.reviewerList = res || []
      })
    },

    // 转办下拉列表
    getTransferList() {
      if (this.detail.orderStatus === '0') {
        return this.feedbackList
      } else if (this.detail.orderStatus === '1') {
        return this.reviewerList
      }
    },

    // 获取工单状态名/颜色
    getStatus(status) {
      return this.orderStatusList[Number(status)] || {}
    },

    // 地图定位
    onAddressShow() {
      this.addressShow = true
      const lng = Number(this.detail.longitude)
      const lat = Number(this.detail.latitude)
      this.$nextTick(() => {
        this.initMap(lng, lat)
      })
    },

    // 初始化地图
    initMap(lng, lat) {
      if (this.map) {
        this.map.setCenter([lng, lat])
      } else {
        AMap.plugin(['AMap.MouseTool'], () => {
        })
        this.map = new AMap.Map('map', {
          center: [lng, lat],
          zoom: 15
        })
        this.addMarker(lng, lat)
      }
    },

    addMarker(lng, lat) {
      this.map.remove(this.marker)
      if (lng && lat) {
        this.marker = []
        const marker = new AMap.Marker({
          map: this.map,
          position: new AMap.LngLat(lng, lat),
          offset: new AMap.Pixel(-20, -10),
          icon: LocationImg
        })
        marker.setLabel({
          direction: 'top',
          offset: new AMap.Pixel(0, -5),
          content: `<div class="addressMarker">
                      <span>${this.detail.address}</span>
                    </div>`
        })
        this.marker.push(marker)
        this.map.add(marker)
      }
    },

    // 定位到办理流程
    changeTab() {
      const anchor = document.getElementById(this.activeName)
      anchor && anchor.scrollIntoView({ behavior: 'smooth' })
    },

    // 处理类型 4：查看 0：反馈 1：审核 2：转办 3：关闭
    toHandle(type) {
      if (type) {
        this.handleDialogType = type
      } else {
        this.handleDialogType = this.detail.orderStatus || ''
      }
      this.handleButtonShow = true
    },

    imgRemove(index) {
      this.info.fileList.splice(index, 1)
    },

    // 文件上传成功返回
    onSuccess(file) {
      this.info.fileList.push(file)
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },

    radioChange(status) {
      this.info.result = status
    },

    toSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitShow = true
          const urlList = this.isMyOrder
            ? [
              this.$apis.workOrder.insertThisWorkOrderFlowTwo,
              this.$apis.workOrder.insertThisWorkOrderFlowTwo,
              this.$apis.workOrder.insertThisWorkOrderFlowOwn,
              this.$apis.workOrder.insertThisWorkOrderFlowClose
            ]
            : [
              this.$apis.workOrder.insertWorkOrderFlowTwo,
              this.$apis.workOrder.insertWorkOrderFlowTwo,
              this.$apis.workOrder.insertYhWoPass,
              this.$apis.workOrder.insertWorkOrderFlowClose
            ]
          const txtList = ['反馈', '审核', '转办', '关闭']
          const flowType = this.handleDialogType === '0' ? '1' : this.handleDialogType === '1' ? '2' : ''
          this.$axios.post(urlList[Number(this.handleDialogType)], {
            ...this.info,
            orderId: this.detail.orderId,
            flowType: flowType
          }).then(() => {
            this.$message.success(txtList[Number(this.handleDialogType)] + '成功')
            this.getDetail()
            this.handleButtonShow = false
            this.clearInfo()
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    // 计算弹窗下边距
    getMarginBottom() {
      const pxList = [405, 335, 285, 235]
      if (this.handleButtonShow) {
        return this.info.fileList.length > 4 ? pxList[Number(this.handleDialogType)] + 105 : pxList[Number(this.handleDialogType)]
      } else {
        return (this.detail.orderStatus === '2' || this.detail.orderStatus === '3') ? 0 : 80
      }
    },

    toClose() {
      this.handleButtonShow = false
      this.handleDialogType = '4'
      this.clearInfo()
    },

    // 关闭弹窗
    handleClose() {
      this.$emit('closeDialog')
      this.clearInfo()
    },

    clearInfo() {
      this.info = {
        remark: '',
        userId: '',
        fileList: [],
        result: '',
        receiveUserId: ''
      }
    }

  }

}
</script>

<style>
.el-drawer__wrapper {
  top: 62px !important;
}
</style>
<style lang='scss' scoped>
@import "@/assets/scss/color";

.radioGroup {
  margin: 0;
}

::v-deep .el-drawer {
  width: 800px !important;

  .el-drawer__header {
    padding: 10px 30px;
    margin-bottom: 0;
    border-bottom: 1px solid #F0F0F0;
  }

  .el-dialog__close {
    &::before {
      font-size: 14px;
    }
  }

  .el-drawer__body {
    position: relative;
    background: #FAFBFB;
  }
}

.orderDetail {
  height: 100%;
  overflow-y: auto;

  .title {
    background: #fff;
    padding-top: 20px;
    display: flex;
    align-items: center;

    .status {
      padding: 1px 9px;
      border-radius: 0 24px 24px 0;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 22px;
      margin-right: 20px;
    }

    .txt {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4A4A4A;
      line-height: 18px;
      margin-right: 50px;
    }
  }

  .theme {
    background: #fff;
    padding: 30px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 32px;
  }

  .detail {
    padding-top: 30px;
    padding-left: 30px;
    border-top: 1px solid #F0F0F0;
    background: #fff;

    .detailItem {
      display: flex;
      padding-bottom: 20px;

      .label,
      .value {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }

      .label {
        width: 110px;
      }

      .value,
      .fileList {
        width: calc(100% - 80px);

        span {
          font-weight: 500;
          color: var(--color-primary);
          margin-left: 30px;
          cursor: pointer;
        }
      }
    }
  }

  .flowList {
    padding: 20px;
    margin-bottom: 80px;

    .flowItem {
      position: relative;
      display: flex;
      padding-bottom: 20px;

      .icon {
        width: 56px;
        height: 36px;
        margin-top: 30px;

        .iconfont {
          position: relative;
          font-size: 35px;
          color: var(--color-primary);
          z-index: 2;
        }

        .closeItem {
          position: relative;
          width: 50px;
          height: 26px;
          background: #9B9B9B;
          border-radius: 3px;
          z-index: 2;
        }

        span {
          color: #FFF;
          font-size: 14px;
          position: absolute;
          left: 10px;
          top: 32px;
          z-index: 3;
        }

        &::before {
          content: '';
          position: absolute;
          top: 0px;
          left: 24px;
          width: 2px;
          height: calc(100%);
          background: #F4F4F4;
          z-index: 1;
        }
      }

      &:first-child {
        .icon::before {
          top: 30px;
        }
      }

      &:last-child {
        .icon::before {
          height: 56px;
        }
      }

      .flowInfo {
        width: 100%;
        margin-left: 22px;
        background-color: #fff;
        border-radius: 6px;
        padding: 14px 14px 20px 30px;

        .info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .infoRole {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #474A59;
            line-height: 22px;
          }

          .infoTime {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
          }
        }

        .name {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 22px;
          margin-bottom: 10px;
        }

        .remark {
          width: 100%;
          background: #FBFBFB;
          border-radius: 4px;
          padding: 10px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #484A59;
          line-height: 22px;
          margin-bottom: 15px;

          >div:first-child {
            margin-bottom: 8px;

            .leftWidth {
              font-weight: 500;
              color: #000000;
              margin-left: 10px;
            }
          }
        }
      }
    }

  }

  .handleForm {
    width: 100%;
    position: absolute;
    bottom: 80px;
    padding: 30px 0 0 20px;
    display: flex;
    border-top: 1px solid #DADEE2;
    background: #FAFBFB;
    z-index: 99;

    .icon {
      width: 50px;
      height: 36px;

      .iconfont {
        position: relative;
        font-size: 35px;
        color: var(--color-primary);
        z-index: 2;
      }

      span {
        color: #FFF;
        font-size: 14px;
        position: absolute;
        left: 32px;
        top: 32px;
        z-index: 3;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 44px;
        width: 2px;
        height: calc(100%);
        background: #F4F4F4;
        z-index: 1;
      }
    }

    .form {
      margin-bottom: 20px;

      .radioItem {
        display: flex;
        align-items: center;
        cursor: pointer;

        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          margin: 0 30px 0 10px;
        }
      }
    }
  }

  .handleButton {
    width: 100%;
    height: 80px;
    background: #FFF;
    border-radius: 1px;
    position: absolute;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;

    .check {
      .el-button {
        height: 42px;
        width: 80px;

        &:nth-child(2) {
          background-color: #F5A623;
          margin-left: 8px;
          border: 1px solid #F5A623;
        }

        &:nth-child(3) {
          margin-left: 8px;
        }
      }
    }

    .handle {
      .el-button {
        height: 42px;
        width: 80px;

        &:nth-child(2) {
          margin-left: 8px;
        }
      }
    }

    .closeBtn {
      height: 42px;
      width: 80px;
      margin-left: 8px;
    }
  }
}

.fileList {
  display: flex;
  flex-wrap: wrap;

  .fileBlock {
    position: relative;
    height: 140px;
    width: 140px;
    margin: 0 20px 20px 0;

    &:nth-child(4n) {
      margin-right: 0px;
    }

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;
  }
}

.imgList {
  display: flex;
  flex-wrap: wrap;

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin: 0 10px 10px 0;

    .el-image,
    img,
    video {
      width: 100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }

    i:hover {
      color: #ffffff98;
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding: 25px 10px;
  }
}

::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}

#map {
  width: 100%;
  height: 450px;
  border-radius: 0 0 10px 10px;
}

::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 22px 20px;
  display: flex;
  align-items: center;

  .el-dialog__title {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    text-shadow: 0px 6px 14px rgba(205, 205, 205, 0.5);
  }

  .el-dialog__close {
    &::before {
      font-size: 16px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 2px;
  position: relative;

  .el-input--small .el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .el-input__prefix {
    padding-top: 3px;
  }
}

::v-deep .amap-marker-label {
  border: none;
  background: transparent;

  .addressMarker {
    background: #FAFAFA;
    box-shadow: 0px 2px 4px 0px rgba(144, 144, 144, 0.5);
    border-radius: 4px;
    padding: 7px 14px;
    display: inline-block;
    text-align: center;

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4A4A4A;
      line-height: 10px;
    }
  }
}
</style>
